/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerOverviewResource } from './';
import {
    FreelancerOverviewResourceFromJSON,
    FreelancerOverviewResourceFromJSONTyped,
    FreelancerOverviewResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerInformationResource
 */
export interface FreelancerInformationResource {
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerInformationResource
     */
    complianceInvalidStates: Array<FreelancerInformationResourceComplianceInvalidStatesEnum>;
    /**
     * 
     * @type {FreelancerOverviewResource}
     * @memberof FreelancerInformationResource
     */
    freelancer: FreelancerOverviewResource;
}


/**
 * @export
 */
export const FreelancerInformationResourceComplianceInvalidStatesEnum = {
    BankInformation: 'BANK_INFORMATION',
    BusinessDetails: 'BUSINESS_DETAILS',
    ComplianceDocuments: 'COMPLIANCE_DOCUMENTS'
} as const;
export type FreelancerInformationResourceComplianceInvalidStatesEnum = typeof FreelancerInformationResourceComplianceInvalidStatesEnum[keyof typeof FreelancerInformationResourceComplianceInvalidStatesEnum];


/**
 * Check if a given object implements the FreelancerInformationResource interface.
 */
export function instanceOfFreelancerInformationResource(value: object): value is FreelancerInformationResource {
    if (!('complianceInvalidStates' in value) || value['complianceInvalidStates'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    return true;
}

export function FreelancerInformationResourceFromJSON(json: any): FreelancerInformationResource {
    return FreelancerInformationResourceFromJSONTyped(json, false);
}

export function FreelancerInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'complianceInvalidStates': json['complianceInvalidStates'],
        'freelancer': FreelancerOverviewResourceFromJSON(json['freelancer']),
    };
}

export function FreelancerInformationResourceToJSON(value?: FreelancerInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'complianceInvalidStates': value['complianceInvalidStates'],
        'freelancer': FreelancerOverviewResourceToJSON(value['freelancer']),
    };
}

